import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import unescapedText from 'I18n/utils/unescapedText';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';

const StorefrontViewToggle = ({
  activeView,
  onChange
}) => {
  return /*#__PURE__*/_jsxs(UIButtonGroup, {
    className: "p-right-4",
    children: [/*#__PURE__*/_jsx(UIIconButton, {
      active: activeView === 'list',
      "aria-label": unescapedText('marketplace-assets-ui.storefront.viewToggle.listView'),
      "data-test-id": "storefront-list-view-button",
      onClick: () => {
        onChange('list');
      },
      use: "tertiary-light",
      size: "small",
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "listView"
      })
    }), /*#__PURE__*/_jsx(UIIconButton, {
      active: activeView === 'grid',
      "aria-label": unescapedText('marketplace-assets-ui.storefront.viewToggle.gridView'),
      onClick: () => {
        onChange('grid');
      },
      use: "tertiary-light",
      size: "small",
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "grid",
        size: "small"
      })
    })]
  });
};

export default StorefrontViewToggle;